/**
=========================================================
* Soft UI Dashboard React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import axios from 'axios';  
import React from 'react';  
import { useLocation, Link } from "react-router-dom";
import { FaForward } from "react-icons/fa";

// @mui material components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import SoftInput from "components/SoftInput";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { Helmet } from "react-helmet";
import FormSelect from 'react-bootstrap/FormSelect';

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import {useEffect, useState, useRef} from 'react';
import Modal from 'react-modal';
import Button from 'react-bootstrap/Button';

// Data
//import groupsTableData from "layouts/groups/data/groupsTableData";

import SoftAvatar from "components/SoftAvatar";
import SoftBadge from "components/SoftBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

import step1 from "assets/images/step1.png";
import step2 from "assets/images/step2.png";
import step3 from "assets/images/step3.png";
import step4 from "assets/images/step4.png";
import gr_logo from "assets/images/group.png";

import { Navigate } from "react-router-dom";
import SoftButton from "components/SoftButton";
import { FaPenSquare } from "react-icons/fa";
import { FaImage } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
// Rich text editor imports removed to avoid dependency issues

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};


function Author({ image, name, email }) {
  return (
    <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
      <SoftBox mr={2}>
        <SoftAvatar src={image} alt={name} size="sm" variant="rounded" />
      </SoftBox>
      <SoftBox display="flex" flexDirection="column" >
        <SoftTypography variant="button" fontWeight="medium" color="info">
          {name}
        </SoftTypography>
        <SoftTypography variant="caption" color="secondary">
          {email}
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
};
function Function({ job, org }) {
  return (
    <SoftBox display="flex" flexDirection="column">
      <SoftTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </SoftTypography>
      <SoftTypography variant="caption" color="secondary">
        {org}
      </SoftTypography>
    </SoftBox>
  );
};

export default class Groups extends React.Component {  
  constructor(props) {
    super(props);
    this.setState({loggedIn: '1'});
    this.setState({showModal: false});
    this.setState({showModalTelegram: false});
    
    this.setState({viewstatus: 'list'});

    this.state = { 
      loggedIn: '1',
      showModal: false,
      viewstatus:'list', 
      groupSaveLoading: false,
      showDescriptionModal: false,
      selectedGroupDescription: '',
      descriptionUpdateLoading: false,
      show_all: false
    };

  }
  state = {  
    posts: [],
    whatsappLoading: false,
    whatsappMembers: [],
    selectedMembers: [],
    whatsappMembersLoading: false,
    selectedMainGroupId: null,
    selectedGuestGroupId: null,
    selectedCheckMembersGroupId: null,
    whatsappNotificationClicked: false
  }  


// Function to fetch WhatsApp group members
fetchWhatsappMembers = () => {
  this.setState({ whatsappMembersLoading: true });
  
  axios.get(global.config.app.backend_api_url + 'groups/get_whatsapp_group_members', { withCredentials: true })
    .then(res => {
      if(res.data.status === 1) {
        const whatsappMembers = res.data.whatsapp_members || [];
        // Select all members by default (all mobile numbers)
        const allMobileNumbers = whatsappMembers.map(member => member.mobile_no);
        
        this.setState({ 
          whatsappMembers: whatsappMembers,
          selectedMembers: allMobileNumbers // All members selected by default
        });
      } else {
        console.error('Error fetching WhatsApp members:', res.data.message);
        alert('Error loading WhatsApp members: ' + res.data.message);
      }
      this.setState({ whatsappMembersLoading: false });
    })
    .catch(error => {
      console.error('Error fetching WhatsApp members:', error);
      alert('Error loading WhatsApp members. Please try again.');
      this.setState({ whatsappMembersLoading: false });
    });
};

// Function to handle checkbox selection
handleMemberSelection = (mobileNo, isChecked) => {
  let updatedSelectedMembers = [...this.state.selectedMembers];
  
  if (isChecked) {
    // Add member if not already selected
    if (!updatedSelectedMembers.includes(mobileNo)) {
      updatedSelectedMembers.push(mobileNo);
    }
  } else {
    // Remove member if unchecked
    updatedSelectedMembers = updatedSelectedMembers.filter(member => member !== mobileNo);
  }
  
  this.setState({ selectedMembers: updatedSelectedMembers });
};

onClickGroupWAMembersListRefresh = (e)=> {
  var group_id = this.state.selected_group;

  

  const post_data = { group_id:group_id};

    axios.post( global.config.app.backend_api_url + `whats/Fetchgroupmembers/update`,post_data, { withCredentials: true }
  )  
    .then(res => {  
      //const normalmembers = res.data;  
      if(res.data.status=='0')
      {
        alert(res.data.message);
      }
      else
      {
          alert(res.data.message);
        
        //  this.callbasicapi();
         // this.setState({viewstatus: 'list'});
        
      }

    });

 
}

onClickCheckWhatsappList = (e)=> {
  var group_id = this.state.selected_group;

  
 var url  = global.config.app.backend_api_url + `wa_members/GroupUsers/index?group_id=`+group_id;
window.location.href = url;
 
 
}

onClickGroupWAUpdate = (e)=> {
  var group_id = this.state.selected_group;

  // Read from state first, fallback to DOM for backward compatibility
  var wa_main_chat_id = this.state.selectedMainGroupId || (document.getElementById('wa_main_chat_id')?.value || '');
  var wa_guest_chat_id = this.state.selectedGuestGroupId || (document.getElementById('wa_guest_chat_id')?.value || '');
  var wa_check_members_group = this.state.selectedCheckMembersGroupId || (document.getElementById('wa_check_members_group')?.value || '');


  const post_data = { group_id:group_id, wa_guest_chat_id: wa_guest_chat_id,wa_main_chat_id : wa_main_chat_id 
  ,wa_check_members_group:wa_check_members_group};

    axios.post( global.config.app.backend_api_url + `groups/update_wa_group`,post_data, { withCredentials: true }
  )  
    .then(res => {  
      //const normalmembers = res.data;  
      if(res.data.status=='0')
      {
        alert(res.data.message);
      }
      else
      {
          alert(res.data.message);
        
        //  this.callbasicapi();
          this.setState({viewstatus: 'list'});
        
      }

    });

 
}
onClickGroupSave = (e)=> {
  this.setState({ groupSaveLoading: true });
  var group_name = document.getElementById('group_name').value
  var group_id = this.state.selected_group;

  var location = document.getElementById('location').value
  var main_telegram_chat_id = document.getElementById('main_telegram_chat_id').value
  var guest_telegram_chat_id = document.getElementById('guest_telegram_chat_id').value

  // Get selected WhatsApp members
  const members_mobile_no = this.state.selectedMembers;

  const post_data = { 
    group_id: group_id, 
    group_name: group_name,
    location: location,
    main_telegram_chat_id: main_telegram_chat_id,
    guest_telegram_chat_id: guest_telegram_chat_id,
    members_mobile_no: members_mobile_no
  };

    axios.post( global.config.app.backend_api_url + `groups/add_edit_group`,post_data, { withCredentials: true }
  )  
    .then(res => {  
      //const normalmembers = res.data;  
      console.log("after112")
      console.log(res.data)
      if(res.data.status=='0')
      {
        alert(res.data.message);
        this.setState({ groupSaveLoading: false });
      }
      else
      {
        alert(res.data.message);
        this.callbasicapi();
        this.setState({viewstatus: 'list'});
        this.setState({ groupSaveLoading: false });
        // Reset selected members after successful save
        this.setState({ selectedMembers: [], whatsappMembers: [] });
      }
    })
    .catch(() => { this.setState({ groupSaveLoading: false }); });



// alert('API to be called');
}

// Description update methods
openDescriptionModal = (groupId, currentDescription = '') => {
  console.log('openDescriptionModal called with:', { groupId, currentDescription });
  this.setState({
    showDescriptionModal: true,
    selected_group: groupId,
    selectedGroupDescription: currentDescription || ''
  });
};

closeDescriptionModal = () => {
  this.setState({
    showDescriptionModal: false,
    selectedGroupDescription: '',
    descriptionUpdateLoading: false
  });
};

updateGroupDescription = () => {
  this.setState({ descriptionUpdateLoading: true });
  
  const post_data = {
    group_id: this.state.selected_group,
    description: this.state.selectedGroupDescription
  };

  axios.post(global.config.app.backend_api_url + 'groups/update_group_description', post_data, { withCredentials: true })
    .then(res => {
      if(res.data.status === '0') {
        alert(res.data.message);
      } else {
        alert('Group description updated successfully!');
        this.callbasicapi();
      }
      this.setState({ descriptionUpdateLoading: false });
      this.closeDescriptionModal();
    })
    .catch((error) => {
      console.error('Error updating description:', error);
      alert('Error updating description. Please try again.');
      this.setState({ descriptionUpdateLoading: false });
    });
};
callbasicapi()
{
  const post_data = { show_all: this.state.show_all ? '1' : '0'};

      //show_all
  axios.post(global.config.app.backend_api_url +`groups/index`,post_data, { withCredentials: true })  
  .then(res => {  
    //const posts = res.data;  
    const posts = this.createRows(res.data.group_data);
    console.log("getting group response ");
    //console.log(res.data)
    this.setState({ posts });  
    //alert(res.data.user_details.user_id)
    if(res.data.user_details.user_id!='')
    {
      this.callNotificationSubscribe(res.data.user_details.nai,res.data.user_details.user_id);
    }
  });
}

onImageChange = event => {
  if (event.target.files && event.target.files[0]) {
    let img = event.target.files[0];
    //alert(this.state.selected_group)

    const formData = new FormData();
    formData.append("group_logo_img", event.target.files[0]);
    formData.append("group_id", this.state.selected_group);
    //call API

    axios.post( global.config.app.backend_api_url + `groups/uploadgrouplogo`,formData, { withCredentials: true }
    )  
      .then(res => {  
        //const normalmembers = res.data;  
        console.log("after112")
        console.log(res.data)
        if(res.data.status=='0')
        {
          alert(res.data.message);
        }
        else
        {
          alert(res.data.message);
          //alert(res.data.profile_pic)
          /*
          this.setState({
            image: URL.createObjectURL(img)
          });
          */
          this.callbasicapi();
          this.setState({ selected_group : '', viewstatus: 'list'});

        }
  
      });

      

   
  }
};
closeModalTelegram = e => {
  this.setState({
    showModalTelegram: false
  });

};
generateWhatsappcode(type,e)
{
  // Show loader
  this.setState({ whatsappLoading: true });
  
  // Set flag to show WhatsApp buttons when 'WM' (WhatsApp Notification) is clicked
  if (type === 'WM') {
    this.setState({ whatsappNotificationClicked: true });
  }
  
  var typename='Main Group';
  if(type=='WG')
  {
    typename='Guest Group';
  }
  const post_data = { ref_type:type,group_id:this.state.selected_group};

    axios.post( global.config.app.backend_api_url + `connect/generatewhatsappcode`,post_data, { withCredentials: true }
  )  
    .then(res => {  
      //const normalmembers = res.data;  
      console.log("after112")
      console.log(res.data)
      if(res.data.status=='0')
      {
        //alert(res.data.message);
        this.setState({ whatsappLoading: false });
      }
      else
      {
        
        this.setState({available_whatsapp_groups: res.data.available_whatsapp_groups,sel_wa_main_chat_id:res.data.wa_main_chat_id,
        sel_wa_guest_chat_id:res.data.wa_guest_chat_id
      });

        //alert(res.data.wa_main_chat_id)

        setTimeout(() => {
          const mainChatId = res.data.wa_main_chat_id;
          const guestChatId = res.data.wa_guest_chat_id;
          const checkMembersGroupId = res.data.wa_check_members_group;
          
          this.setState({
            selectedMainGroupId: mainChatId || null,
            selectedGuestGroupId: guestChatId || null,
            selectedCheckMembersGroupId: checkMembersGroupId || null
          });
          
          // Set hidden input values
          const mainInput = document.getElementById('wa_main_chat_id');
          const guestInput = document.getElementById('wa_guest_chat_id');
          const checkInput = document.getElementById('wa_check_members_group');
          if (mainInput) {
            mainInput.value = mainChatId || '';
          }
          if (guestInput) {
            guestInput.value = guestChatId || '';
          }
          if (checkInput) {
            checkInput.value = checkMembersGroupId || '';
          }
        }, 1500);


        //wa_check_members_group
        
        document.getElementById('whatsapp_div').style.display='';
        
        // Hide loader
        this.setState({ whatsappLoading: false });
        
          //this.setState({telegramsecret: res.data.code,telegramtypename:typename});
        
      }

    })
    .catch(error => {
      console.error('Error generating WhatsApp code:', error);
      this.setState({ whatsappLoading: false });
    });
}
generateTelegramcode(type,e)
{
  var typename='Main Group';
  if(type=='GG')
  {
    typename='Guest Group';
  }
  const post_data = { ref_type:type,group_id:this.state.selected_group};

    axios.post( global.config.app.backend_api_url + `connect/generatetelegramcode`,post_data, { withCredentials: true }
  )  
    .then(res => {  
      //const normalmembers = res.data;  
      console.log("after112")
      console.log(res.data)
      if(res.data.status=='0')
      {
        //alert(res.data.message);
      }
      else
      {
        document.getElementById('telegram_div_demo').style.display='';
        
          this.setState({telegramsecret: res.data.code,telegramtypename:typename});
        
      }

    });

  //call API
  //this.setState({showModalTelegram: !this.state.showModalTelegram }); //!this.state.showModalTelegram
}

  componentDidMount() {  

    const post_data = { lo : 1};

    axios.post( global.config.app.backend_api_url + `login/sessionavailable`,post_data, { withCredentials: true }
    )  
      .then(res => {  
        console.log(res.data)
        var user_id = res.data.user_details.user_id;
        
        if (user_id !== undefined && user_id !== null && user_id !== 'null') 
        {
        }else
        {
          window.location.replace('sign-in');
          //return;
        }
  
      });

      this.callbasicapi();

      /*
      axios.get(`http://localhost:9000/testAPIp`, { withCredentials: true })  
      .then(res => {  
        this.setState({loggedIn: res.data.loggedIn, designation: "your value"});

      });*/

      // Handle hash navigation to WhatsApp notification section
      this.handleHashNavigation();

  }

  componentDidUpdate(prevProps, prevState) {
    // Handle hash navigation when component updates
    if (this.state.viewstatus !== prevState.viewstatus) {
      setTimeout(() => {
        this.handleHashNavigation();
      }, 100);
    }
  }

  handleHashNavigation = () => {
    // Check if URL has hash for WhatsApp notification
    if (window.location.hash === '#whatsapp-notification') {
      // Read group_id from URL query parameter if present
      let search = window.location.search;
      let params = new URLSearchParams(search);
      let group_id = '';
      if (params.get('g') != null) {
        try {
          group_id = params.get('g');
        } catch (e) {
          console.error('Error decoding group_id:', e);
        }
      }
      //alert(group_id)
      // Set viewstatus to 'create' and selected_group if group_id is provided
      if (this.state.viewstatus !== 'create' || (group_id && this.state.selected_group !== group_id)) {
        const newState = { viewstatus: 'create',selected_group:group_id };
        this.setState({ selectedMembers: [], whatsappMembers: [] });
        if (group_id) {
         // newState.selected_group = group_id;
          // Auto-fetch WhatsApp members when editing a group
          setTimeout(() => this.fetchWhatsappMembers(), 100);
        }
        
        this.setState(newState, () => {
          // Wait for the form to render, then scroll to the section
          setTimeout(() => {
            const element = document.getElementById('whatsapp-notification');
            if (element) {
              element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }, 500);
        });
      } else {
        // If already in create view with correct group, just scroll
        setTimeout(() => {
          const element = document.getElementById('whatsapp-notification');
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 300);
      }
    }
  }  

  callNotificationSubscribe(appid,userid)
  {
    if(userid=='' || appid=='')
    {
      return;
    }
    const s = document.createElement("script")
    s.src = "https://notix.io/ent/current/enot.min.js"
    s.onload = (sdk) => {
        sdk.startInstall({
            appId: appid,
            loadSettings: true,
            disableConsoleDebug: true,
            user: userid
        });

    }
    document.head.append(s);
  }
    
  deleteRow(id, e){  
    console.log("deleted id : "+ id);
    console.log( this.state.posts);
    const posts = this.state.posts.filter(item => item.id !== id);  
    this.setState({ posts }); 
    /*
    axios.delete(`http://localhost:9000/groups/${id}`)  
      .then(res => {  
        console.log(res);  
        console.log(res.data);  
    
        const posts = this.state.posts.filter(item => item.id !== id);  
        this.setState({ posts });  
      })  */
    
  }  

  
  
  

   groupsTableData = {
    columns: [
      { name: "slno", align: "left" },
      { name: "groupname", align: "left" },
      { name: "location", align: "left" },
      { name: "memberscount", align: "left" },
      { name: "createdon", align: "left" },
      { name: "action", align: "left" },
    ],
  
    rows: [
      {
        groupname: <Author image={team2} name="Friends Group"  />,
        location: <Function job="Trivandrum"  />,
        memberscount: (
          <SoftTypography variant="caption" color="secondary" fontWeight="medium">
            25
          </SoftTypography>
        ),
        createdon: (
          <SoftTypography variant="caption" color="secondary" fontWeight="medium">
            12/11/2022
          </SoftTypography>
        ),
        action: (
          <SoftBox>
          <SoftTypography
            component="a"
            href="#"
            variant="caption"
            color="secondary"
            fontWeight="medium"
          >
            Edit
          </SoftTypography>

          <SoftTypography
          component="a"
          href="#"
          variant="caption"
          color="secondary"
          fontWeight="medium"
          >
          View
          </SoftTypography>
          </SoftBox>

        ),
      }
      
    ],
  };

  createRows(res)
{
  //loop here and create rows in soft UI rows
  console.log(res)
  const plainObj = [];
  let link_to_schedules = "/schedules";

  var iloop ;
  for(iloop=0; iloop < res.length; iloop++){
      const thisid = res[iloop].id;
      const href_link = "/viewmembers?id="+btoa(thisid);
      const is_admin= res[iloop].is_admin;
      const currentGroup = res[iloop]; // Capture current group data

      let querystring1 = "?g="+btoa(thisid);

      //loopData += `<li>${data[i].name}</li>`
      var arrayLike = {};
      if(res[iloop].is_admin  =='1')
      {
         arrayLike = {
          slno: (
            <SoftTypography variant="caption" color="secondary" fontWeight="medium">
              {iloop + 1}
            </SoftTypography>
          ),
          groupname: (
          <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
        <SoftBox mr={2}>
          <SoftAvatar src={res[iloop].group_logo ? (res[iloop].group_logo):(gr_logo)} alt={res[iloop].groupname} size="sm" variant="rounded" />
        </SoftBox>
        <SoftBox display="flex" flexDirection="column" >
          <SoftTypography component="a" href={href_link}  variant="button" fontWeight="medium" color="info">
          {res[iloop].groupname}
          </SoftTypography>
          
        </SoftBox>
      </SoftBox>
  ),
          location: <Function job={res[iloop].location}  />,
          memberscount: (
            <SoftTypography variant="caption" color="secondary" fontWeight="medium">
              {res[iloop].members_count}
            </SoftTypography>
          ),
          'createdon': res[iloop].createdon,
          'action' : (
            <SoftBox>{/*
            <SoftTypography
              component="a"
              href="#"
              variant="caption"
              color="secondary"
              fontWeight="medium"
              onClick={() => this.deleteRow(thisid)}
            >
              View&nbsp;&nbsp;
            </SoftTypography>
           */}
            <SoftBox
              component="a"
              href="javascript:void(0)"
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                backgroundColor: 'rgba(25, 118, 210, 0.1)',
                color: '#1976d2',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                marginRight: '8px',
                '&:hover': {
                  backgroundColor: 'rgba(25, 118, 210, 0.2)',
                  transform: 'scale(1.1)',
                  boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
                },
                '&:active': {
                  transform: 'scale(0.95)',
                }
              }}
              title="Edit Group"
              onClick={() => {
                //alert(thisid)
                this.setState({viewstatus: 'create',selected_group:thisid, whatsappNotificationClicked: false});
                // Reset WhatsApp members when editing group
                this.setState({ selectedMembers: [], whatsappMembers: [] });
                // Auto-fetch WhatsApp members for edit mode
                setTimeout(() => this.fetchWhatsappMembers(), 100);
              }}
            >
              <FaPenSquare size={16} />
            </SoftBox>
            
            <SoftBox
              component="a"
              href="javascript:void(0)"
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                backgroundColor: 'rgba(76, 175, 80, 0.1)',
                color: '#4caf50',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                marginRight: '8px',
                '&:hover': {
                  backgroundColor: 'rgba(76, 175, 80, 0.2)',
                  transform: 'scale(1.1)',
                  boxShadow: '0 4px 12px rgba(76, 175, 80, 0.3)',
                },
                '&:active': {
                  transform: 'scale(0.95)',
                }
              }}
              title="Upload Logo"
              onClick={() => this.setState({viewstatus: 'uploadlogo',selected_group:thisid})}
            >
              <FaImage size={16} />
            </SoftBox>

            <SoftBox
              component="a"
              href="javascript:void(0)"
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                backgroundColor: 'rgba(156, 39, 176, 0.1)',
                color: '#9c27b0',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                marginRight: '8px',
                '&:hover': {
                  backgroundColor: 'rgba(156, 39, 176, 0.2)',
                  transform: 'scale(1.1)',
                  boxShadow: '0 4px 12px rgba(156, 39, 176, 0.3)',
                },
                '&:active': {
                  transform: 'scale(0.95)',
                }
              }}
              title="Update Description"
              onClick={() => {
                try {
                  const description = currentGroup && currentGroup.description ? currentGroup.description : '';
                  this.openDescriptionModal(thisid, description);
                } catch (error) {
                  console.error('Error in onClick:', error);
                  this.openDescriptionModal(thisid, '');
                }
              }}
            >
              <FaEdit size={16} />
            </SoftBox>

            <Link to={{pathname:link_to_schedules,search:querystring1}} style={{ textDecoration: 'none' }}>
              <SoftBox
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '8px 16px',
                  borderRadius: '20px',
                  backgroundColor: 'rgba(255, 152, 0, 0.1)',
                  color: '#ff9800',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  border: '1px solid rgba(255, 152, 0, 0.2)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 152, 0, 0.2)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 16px rgba(255, 152, 0, 0.3)',
                    border: '1px solid rgba(255, 152, 0, 0.4)',
                  },
                  '&:active': {
                    transform: 'translateY(0)',
                  }
                }}
                title="View Schedules"
              >
                <FaForward size={14} style={{ marginRight: '6px' }} />
                <SoftTypography
                  variant="caption"
                  fontWeight="medium"
                  color="inherit"
                  sx={{ fontSize: '0.75rem' }}
                >
                  Schedules
                </SoftTypography>
              </SoftBox>
            </Link>

            

            </SoftBox>
            
          ),
          'id' : res[iloop].id
        };
      }
      else  //not admin
      {
         arrayLike = {
        slno: (
          <SoftTypography variant="caption" color="secondary" fontWeight="medium">
            {iloop + 1}
          </SoftTypography>
        ),
        groupname: (
        <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
      <SoftBox mr={2}>
        <SoftAvatar src={team2} alt={res[iloop].groupname} size="sm" variant="rounded" />
      </SoftBox>
      <SoftBox display="flex" flexDirection="column" >
        <SoftTypography component="a" href={href_link}  variant="button" fontWeight="medium" color="info">
        {res[iloop].groupname}
        </SoftTypography>
        
      </SoftBox>
    </SoftBox>
),
        location: <Function job={res[iloop].location}  />,
        memberscount: (
          <SoftTypography variant="caption" color="secondary" fontWeight="medium">
            25
          </SoftTypography>
        ),
        'createdon': res[iloop].createdon,
        'action' : (
          <SoftBox>
            {/*
          <SoftTypography
            component="a"
            href="#"
            variant="caption"
            color="secondary"
            fontWeight="medium"
            onClick={() => this.deleteRow(thisid)}
          >
            View&nbsp;&nbsp;
            </SoftTypography>*/}

          
          </SoftBox>
          
        ),
        'id' : res[iloop].id
      };
      }//arrayLike

      Array.prototype.push.call(plainObj, arrayLike);

  }
  
    //const myObjStr = JSON.stringify(plainObj);
    console.log("obj:")
    console.log(plainObj)
    console.log("res:")
    console.log(res)
    
    return plainObj;
  }

  
  


  render() {  

    const handleClose = () => {
      this.setState({showModal: false});
    }
    const handleShow = () => {
      this.setState({showModal: true});
    }

    if(this.state.loggedIn!=='1')
    {
     // return <Navigate to="/sign-in" />
  
    };

  const { columns, rows } = this.groupsTableData;


  //const [list, setList] = useState([]);
  //const [actuallist, setActuallist] = useState([]);

    console.log("sess_data:");  
    console.log(this.state.loggedIn);  

    return (  
      <DashboardLayout>
      <Helmet>
      <title>My Groups | {global.config.app.name}</title>
      <meta
        name="description"
    content="Join Our Cricket Team - Experience the thrill of competitive cricket and be part of a supportive community. Sign up now and showcase your skills on the field."
      />
      <meta
        name="keywords"
        content="Cricket, team, join, competitive, skills, community, sign up, field"
      />
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </Helmet>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={2} px={3}>
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.show_all}
                onChange={(e) => {
                  this.setState({ show_all: e.target.checked }, () => {
                    this.callbasicapi();
                  });
                }}
              />
            }
            label="Show all"
          />
        </SoftBox>
        <SoftBox mb={3}>
        {
                (() => {
                  if(this.state.viewstatus === 'list' ){ 
                   return (
          <Card>
            <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
              <SoftTypography variant="h6">My Groups</SoftTypography>
              

              {
                  //  alert(this.state.main_auction_details.pending_count)
                  (() => {
                    let link_to_update = global.config.app.backend_api_url + `admin/users`;
                            return (
                              <a href={link_to_update}>
                              <SoftButton variant="gradient" size="small" color="info" >
                                Update Users
                              </SoftButton></a>
                            )
                    
                  })()
                }

              
              <SoftButton variant="gradient" size="small" color="info"  onClick={() => {
                this.setState({viewstatus: 'create',selected_group:'', whatsappNotificationClicked: false});
                // Reset WhatsApp members when creating new group
                this.setState({ selectedMembers: [], whatsappMembers: [] });
                // Auto-fetch WhatsApp members for new group
                setTimeout(() => this.fetchWhatsappMembers(), 100);
              }}>
                Add a new Group
              </SoftButton>
              
            </SoftBox>
            <SoftBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              <Table columns={columns} rows={this.state.posts} />
            </SoftBox>
          </Card>
        )}
        else if(this.state.viewstatus === 'uploadlogo' )
        { 
          return (
            <Card>

<SoftBox p={3} mb={1} textAlign="center">
<SoftTypography variant="h5" fontWeight="medium">
  Change Group Logo
</SoftTypography>
</SoftBox>

<SoftBox pt={2} pb={3} px={3}>
<SoftBox component="form" role="form" id="groupform">
  
<SoftBox mb={2}>
   <SoftInput type="file" name="g_group_logo_img" id="g_group_logo_img" placeholder="Profile pic" onChange={this.onImageChange}  />

 
  </SoftBox>
  
</SoftBox>

<Link to="/groups">
      
        <SoftTypography
          variant="button"
          fontWeight="medium"
          color="dark"
          onClick={() => this.setState({viewstatus: 'list',selected_group:''})}
        >
          Back 
        </SoftTypography>
      
    </Link>
   

</SoftBox>

</Card>
          )
        }
        else if(this.state.viewstatus === 'create' )
        { 


          let group_caption='New Group';
          let group_save_btn = 'Create';
          if(this.state.selected_group !='')
          {
            group_caption = 'Edit Group';
            group_save_btn  ='Update';
          }
      const post_data = { group_id: this.state.selected_group };
      
      
      
      
//      alert(group_id)
//,{headers: {"Content-Type": "application/json"}}
    axios.post( global.config.app.backend_api_url + `groups/getbyid`,post_data, { withCredentials: true }
    )  
      .then(res => {  
        //const normalmembers = res.data;  
        console.log("after112")
        console.log(res.data.group_data)
        //alert(1)
        //alert(res.data.link_data[0].invite_link)

        if (this.state.selected_group !== '')
        {
          document.getElementById("group_name").value = res.data.group_data[0].groupname;
          document.getElementById("location").value = res.data.group_data[0].location;
          document.getElementById("main_telegram_chat_id").value = res.data.group_data[0].main_telegram_chat_id;
          document.getElementById("guest_telegram_chat_id").value = res.data.group_data[0].guest_telegram_chat_id;
        }
        

      });


         return (
          <Card>

        <SoftBox p={3} mb={1} textAlign="center">
          <SoftTypography variant="h5" fontWeight="medium">
            {group_caption}
          </SoftTypography>
        </SoftBox>
        
        <SoftBox pt={2} pb={3} px={3}>
          <SoftBox component="form" role="form" id="groupform">
            <SoftBox mb={2}>
              <SoftInput placeholder="Name" name="group_name" id="group_name" inputProps={{ maxLength: 60}}  />
            </SoftBox>
            <SoftBox mb={2}>
              <SoftInput type="text" name="location" id="location" placeholder="Location" inputProps={{ maxLength: 100}} />
            </SoftBox>

            {/* WhatsApp Members Selection */}
            <SoftBox mb={3}>
              <SoftTypography variant="button" fontWeight="medium" color="dark" mb={2}>
                Select WhatsApp Group Members (Optional)
              </SoftTypography>
              
              <SoftBox mb={2}>
                <SoftButton 
                  variant="outlined" 
                  color="info" 
                  size="small" 
                  onClick={this.fetchWhatsappMembers}
                  disabled={this.state.whatsappMembersLoading}
                >
                  {this.state.whatsappMembersLoading ? (
                    <>
                      <img src={require('assets/images/loader.svg').default} alt="Loading..." style={{ height: 16, marginRight: 8 }} />
                      Loading...
                    </>
                  ) : (
                    'Load WhatsApp Members'
                  )}
                </SoftButton>
              </SoftBox>
              
              {this.state.whatsappMembersLoading && (
                <SoftBox p={2} textAlign="center">
                  <SoftTypography variant="caption" color="secondary">
                    Loading WhatsApp members...
                  </SoftTypography>
                </SoftBox>
              )}
              
              {!this.state.whatsappMembersLoading && this.state.whatsappMembers.length === 0 && (
                <SoftBox p={2} sx={{ backgroundColor: '#f5f5f5', borderRadius: '4px', textAlign: 'center' }}>
                  <SoftTypography variant="caption" color="secondary">
                    No WhatsApp members available. Click "Load WhatsApp Members" to fetch the list.
                  </SoftTypography>
                </SoftBox>
              )}
              
              {this.state.whatsappMembers.length > 0 && (
                <SoftBox 
                  sx={{ 
                    border: '1px solid #e0e0e0', 
                    borderRadius: '8px', 
                    padding: '16px',
                    maxHeight: '300px',
                    overflowY: 'auto',
                    backgroundColor: '#fafafa'
                  }}
                >
                  <SoftBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <SoftTypography variant="caption" color="secondary">
                      All members are selected by default. Uncheck any members you don't want to include ({this.state.selectedMembers.length}/{this.state.whatsappMembers.length} selected):
                    </SoftTypography>
                    <SoftBox display="flex" gap={1}>
                      <SoftButton
                        variant="text"
                        color="info"
                        size="small"
                        onClick={() => {
                          const allMobileNumbers = this.state.whatsappMembers.map(member => member.mobile_no);
                          this.setState({ selectedMembers: allMobileNumbers });
                        }}
                      >
                        Select All
                      </SoftButton>
                      <SoftButton
                        variant="text"
                        color="secondary"
                        size="small"
                        onClick={() => {
                          this.setState({ selectedMembers: [] });
                        }}
                      >
                        Deselect All
                      </SoftButton>
                    </SoftBox>
                  </SoftBox>
                  
                  {this.state.whatsappMembers.map((member, index) => (
                    <SoftBox key={member.mem_id || index} mb={1}>
                      <SoftBox display="flex" alignItems="center">
                        <input
                          type="checkbox"
                          id={`member_${member.mem_id || index}`}
                          checked={this.state.selectedMembers.includes(member.mobile_no)}
                          onChange={(e) => this.handleMemberSelection(member.mobile_no, e.target.checked)}
                          style={{ marginRight: '8px' }}
                        />
                        <label 
                          htmlFor={`member_${member.mem_id || index}`}
                          style={{ 
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1
                          }}
                        >
                          <SoftTypography variant="caption" fontWeight="medium" color="dark">
                            {member.display_name || 'Unknown'}
                          </SoftTypography>
                          <SoftTypography variant="caption" color="secondary">
                            {member.mobile_no}
                          </SoftTypography>
                        </label>
                      </SoftBox>
                    </SoftBox>
                  ))}
                  
                  {this.state.selectedMembers.length > 0 && (
                    <SoftBox mt={2} p={2} sx={{ backgroundColor: '#e3f2fd', borderRadius: '4px' }}>
                      <SoftTypography variant="caption" fontWeight="medium" color="info">
                        Selected Members: {this.state.selectedMembers.length}
                      </SoftTypography>
                    </SoftBox>
                  )}
                </SoftBox>
              )}
            </SoftBox>

            <SoftBox mb={2} style={{display:'none'}}>
              <SoftInput type="text" name="main_telegram_chat_id" id="main_telegram_chat_id" placeholder="Main Telegram Group ID" inputProps={{ maxLength: 20}} />
            </SoftBox>
            <SoftBox mb={2}  style={{display:'none'}}>
              <SoftInput type="text" name="guest_telegram_chat_id" id="guest_telegram_chat_id" placeholder="Guest Telegram Group ID" inputProps={{ maxLength: 20}} />
            </SoftBox>

            

            
            <SoftBox mt={4} mb={1}>
              <SoftButton variant="gradient" color="dark" fullWidth onClick={this.onClickGroupSave} disabled={this.state.groupSaveLoading}>
                {this.state.groupSaveLoading ? (
                  <img src={require('assets/images/loader.svg').default} alt="Saving..." style={{ height: 24 }} />
                ) : (
                  group_save_btn
                )}
              </SoftButton>
            </SoftBox>
            
          </SoftBox>

          <Link to="/groups">
                
                  <SoftTypography
                    variant="button"
                    fontWeight="medium"
                    color="dark"
                    onClick={() => this.setState({viewstatus: 'list',selected_group:'', whatsappNotificationClicked: false})}
                  >
                    Back to list
                  </SoftTypography>
                
              </Link>

            &nbsp;&nbsp;&nbsp;
              
            <SoftTypography
              variant="button"
              color="info"
              fontWeight="medium"
              component={Link}
              to="javascript:void(0)"
              onClick={() => this.generateTelegramcode('GM')}
              textGradient
            >
              Enable Telegram For Main Group ?
            </SoftTypography>


            &nbsp;&nbsp;&nbsp;
              
            <SoftTypography
              variant="button"
              color="info"
              fontWeight="medium"
              component={Link}
              to="javascript:void(0)"
              onClick={() => this.generateTelegramcode('GG')}
               textGradient
            >
              Enable Telegram For Guest Group ?
            </SoftTypography>

            &nbsp;&nbsp;&nbsp;
              
            <SoftBox id="whatsapp-notification">
              <SoftTypography
                variant="button"
                color="info"
                fontWeight="medium"
                component={Link}
                to="javascript:void(0)"
                onClick={() => this.generateWhatsappcode('WM')}
                 textGradient
              >
                Enable Whatsapp Notification ?
              </SoftTypography>
              
              {/* WhatsApp Loading Spinner */}
              {this.state.whatsappLoading && (
                <SoftBox mt={2} display="flex" justifyContent="center" alignItems="center">
                  <SoftBox
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    width="40px"
                    height="40px"
                    borderRadius="50%"
                    border="3px solid #e0e0e0"
                    borderTop="3px solid #17c1e8"
                    animation="spin 1s linear infinite"
                    style={{
                      animation: 'spin 1s linear infinite'
                    }}
                  />
                  <SoftTypography variant="caption" color="secondary" ml={2}>
                    Loading...
                  </SoftTypography>
                </SoftBox>
              )}
            </SoftBox>
            
            &nbsp;&nbsp;&nbsp;
            {/*  
            <SoftTypography
              variant="button"
              color="info"
              fontWeight="medium"
              component={Link}
              to="javascript:void(0)"
              onClick={() => this.generateWhatsappcode('WG')}
               textGradient
            >
              Enable Whatsapp For Guest Group ?
            </SoftTypography>
            */}
        </SoftBox>

        

<SoftBox pt={2} pb={3} px={3}>
        
<SoftBox id="whatsapp_div" style={{display:'none'}} >
            <SoftBox mb={2}>
          
              <SoftTypography
              fontWeight="medium"
            >
              To enable Whatsapp App notifications, Kindly send an email to <a style={{color:'#17c1e8'}} href="mailto:support@4cr.in" target="blank" >support@4cr.in</a> 
              &nbsp;with your details.
              <br/>

            </SoftTypography>

            <SoftBox component="form" role="form" id="groupform">
            <SoftBox mb={2}>
            <SoftTypography variant="button" fontWeight="medium" color="dark" mb={1}>
              Main Group Group ID
            </SoftTypography>
            <Autocomplete
              size="small"
              options={this.state.available_whatsapp_groups || []}
              getOptionLabel={(option) => option ? `${option.name} (${option.id})` : ''}
              value={this.state.available_whatsapp_groups?.find(group => group.id === this.state.selectedMainGroupId) || null}
              onChange={(event, newValue) => {
                const newId = newValue ? newValue.id : null;
                this.setState({ selectedMainGroupId: newId });
                const hiddenInput = document.getElementById('wa_main_chat_id');
                if (hiddenInput) {
                  hiddenInput.value = newId || '';
                }
              }}
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  placeholder="Search and select Main Group"
                />
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
            />
            <input 
              type="hidden" 
              id="wa_main_chat_id" 
              name="wa_main_chat_id" 
              value={this.state.selectedMainGroupId || ''} 
            />
            </SoftBox>
            <SoftBox mb={2}>
            <SoftTypography variant="button" fontWeight="medium" color="dark" mb={1}>
              Guest Group Group ID
            </SoftTypography>
            <Autocomplete
              size="small"
              options={this.state.available_whatsapp_groups || []}
              getOptionLabel={(option) => option ? `${option.name} (${option.id})` : ''}
              value={this.state.available_whatsapp_groups?.find(group => group.id === this.state.selectedGuestGroupId) || null}
              onChange={(event, newValue) => {
                const newId = newValue ? newValue.id : null;
                this.setState({ selectedGuestGroupId: newId });
                const hiddenInput = document.getElementById('wa_guest_chat_id');
                if (hiddenInput) {
                  hiddenInput.value = newId || '';
                }
              }}
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  placeholder="Search and select Guest Group"
                />
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
            />
            <input 
              type="hidden" 
              id="wa_guest_chat_id" 
              name="wa_guest_chat_id" 
              value={this.state.selectedGuestGroupId || ''} 
            />
            </SoftBox>


            <SoftBox mb={2}>
            <SoftTypography variant="button" fontWeight="medium" color="dark" mb={1}>
              Check Registration Whatsapp Group
            </SoftTypography>
            <Autocomplete
              size="small"
              options={this.state.available_whatsapp_groups || []}
              getOptionLabel={(option) => option ? `${option.name} (${option.id})` : ''}
              value={this.state.available_whatsapp_groups?.find(group => group.id === this.state.selectedCheckMembersGroupId) || null}
              onChange={(event, newValue) => {
                const newId = newValue ? newValue.id : null;
                this.setState({ selectedCheckMembersGroupId: newId });
                const hiddenInput = document.getElementById('wa_check_members_group');
                if (hiddenInput) {
                  hiddenInput.value = newId || '';
                }
              }}
              renderInput={(params) => (
                <TextField 
                  {...params} 
                  placeholder="Search and select Check Registration Group"
                />
              )}
              isOptionEqualToValue={(option, value) => option.id === value.id}
            />
            <input 
              type="hidden" 
              id="wa_check_members_group" 
              name="wa_check_members_group" 
              value={this.state.selectedCheckMembersGroupId || ''} 
            />
            </SoftBox>


            
            <SoftBox mt={4} mb={1}>
              <SoftButton variant="gradient" color="dark" fullWidth onClick={this.onClickGroupWAUpdate}>
              Update
              </SoftButton>
            </SoftBox>
            
          </SoftBox>

          {this.state.selected_group && this.state.selected_group !== '' && this.state.whatsappNotificationClicked && (
          <>
            <SoftBox mt={4} mb={1}>
              <SoftButton variant="gradient" color="success" fullWidth onClick={this.onClickGroupWAMembersListRefresh}>
                Refresh Whatsapp Members List
              </SoftButton>
            </SoftBox>

            <SoftBox mt={4} mb={1}>
              <SoftButton variant="gradient" color="success" fullWidth onClick={this.onClickCheckWhatsappList}>
                Check Whatsapp List 
              </SoftButton>
            </SoftBox>
          </>
        )}

            </SoftBox>
</SoftBox>
</SoftBox>

<SoftBox id="telegram_div_demo" style={{display:'none'}} pt={2} pb={3} px={3}>
<SoftBox  >
            <SoftBox mb={2}>
          
              <SoftTypography
              fontWeight="medium"
            > 
        Secret Code : {this.state.telegramsecret}<br/>
        
        To enable Telegram App notifications, follow these steps:<br/>
        
        1. Add the <a style={{color:'#17c1e8'}} href="http://t.me/FourCRIN_bot" target="blank" >@4cr.in</a> bot to your group.<br/>
        <img src={step1} /><br/>
        2. Give it admin rights.<br/>
        <img src={step2} width="50%" /><br/><br/>
        <img src={step3} /><br/>
        3. You will see a secret code on the 4cr.in group page.<br/>
        4. Copy that code and send it as a message to your Telegram group.<br/>
        <img src={step4} width="50%" /><br/>
        5. You're done!<br/>
        

                        </SoftTypography>

  </SoftBox>
  </SoftBox>
  </SoftBox>



          </Card>
        
        )
        }

        else if(this.state.viewstatus === 'edit' )
        { 
         return (
          <Card>

        <SoftBox p={3} mb={1} textAlign="center">
          <SoftTypography variant="h5" fontWeight="medium">
            Update Group 
          </SoftTypography>
        </SoftBox>
        
        <SoftBox pt={2} pb={3} px={3}>
          <SoftBox component="form" role="form" id="groupform">
            <SoftBox mb={2}>
              Group Name
              <SoftInput placeholder="Name" name="group_name" id="group_name" inputProps={{ maxLength: 60}}  />
            </SoftBox>
            <SoftBox mb={2}>
              Location
              <SoftInput type="text" name="location" id="location" placeholder="Location" inputProps={{ maxLength: 100}} />
            </SoftBox>
            <SoftBox mb={2}>Upload Logo
              <SoftInput type="file" name="group_logo" id="group_logo" placeholder="Upload Logo"  />
            </SoftBox>

            <SoftBox mb={2}>Fetch Telegram Main Group Name
              <SoftInput type="text" name="main_telegram_chat_id" id="main_telegram_chat_id" placeholder="Fetch Telegram Main Group Name"  inputProps={{ maxLength: 30,readOnly:true}} />
            </SoftBox>
            <SoftBox mb={2}>Fetch Telegram Guest Group Name
              <SoftInput type="text" name="guest_telegram_chat_id" id="guest_telegram_chat_id" placeholder="Fetch Telegram Guest Group Name"  inputProps={{ maxLength: 30,readOnly:true}} />
            </SoftBox>
            
            <SoftBox mt={4} mb={1}>
              <SoftButton variant="gradient" color="dark" fullWidth onClick={() => this.setState({viewstatus: 'list'})}>
                Update
              </SoftButton>
            </SoftBox>
            
          </SoftBox>

          <Link to="/groups">
                
                  <SoftTypography
                    variant="button"
                    fontWeight="medium"
                    color="dark"
                    onClick={() => this.setState({viewstatus: 'list',selected_group:'', whatsappNotificationClicked: false})}
                  >
                    Back to list
                  </SoftTypography>
                
              </Link>

        </SoftBox>

          </Card>
        
        )
        }
        
      })()
        
        }
        </SoftBox>
        
      </SoftBox>
      
      <Modal
        isOpen={this.state.showModalTelegram}
        onRequestClose={this.closeModalTelegram}
        style={customStyles}
        contentLabel="Modal"
      >
        <h2 >How to enable Telegram notification ?</h2>
        
        <button variant="button" fontWeight="medium" color="info" onClick={this.closeModalTelegram}>close</button>
        <div>
        
        To enable Telegram App notifications, follow these steps:<br/>
        
        1. Add the <a style={{color:'#17c1e8'}} href="http://t.me/FourCRIN_bot" target="blank" >@4cr.in</a> bot to your group.<br/>
        2. Give it admin rights.<br/>
        3. You will see a secret code on the 4cr.in group page.<br/>
        4. Copy that code and send it as a message to your Telegram group.<br/>
        5. You're done!<br/>
        </div>
        
      </Modal>

      {/* Description Update Modal */}
      <Modal
        isOpen={this.state.showDescriptionModal}
        onRequestClose={this.closeDescriptionModal}
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '80%',
            maxWidth: '800px',
            maxHeight: '80vh',
            overflow: 'auto',
            border: 'none',
            borderRadius: '12px',
            padding: '0',
            backgroundColor: '#fff',
            boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000
          }
        }}
        contentLabel="Update Group Description"
      >
        <SoftBox p={3}>
          <SoftBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
            <SoftTypography variant="h5" fontWeight="medium" color="dark">
              Update Group Description
            </SoftTypography>
            <SoftButton
              variant="text"
              color="secondary"
              onClick={this.closeDescriptionModal}
              sx={{ minWidth: 'auto', p: 1 }}
            >
              ✕
            </SoftButton>
          </SoftBox>
          
          <SoftBox mb={3}>
            <SoftTypography variant="body2" color="secondary" mb={2}>
              Use the text area below to update your group description. You can enter plain text or HTML formatting.
            </SoftTypography>
            
            <div style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden' }}>
              <textarea
                value={this.state.selectedGroupDescription}
                onChange={(e) => this.setState({ selectedGroupDescription: e.target.value })}
                placeholder="Enter your group description here..."
                style={{
                  width: '100%',
                  height: '300px',
                  padding: '16px',
                  border: 'none',
                  outline: 'none',
                  resize: 'vertical',
                  fontFamily: 'inherit',
                  fontSize: '14px',
                  lineHeight: '1.5',
                  backgroundColor: '#fff'
                }}
              />
            </div>
          </SoftBox>
          
          <SoftBox display="flex" justifyContent="flex-end" gap={2}>
            <SoftButton
              variant="outlined"
              color="secondary"
              onClick={this.closeDescriptionModal}
              disabled={this.state.descriptionUpdateLoading}
            >
              Cancel
            </SoftButton>
            <SoftButton
              variant="gradient"
              color="info"
              onClick={this.updateGroupDescription}
              disabled={this.state.descriptionUpdateLoading}
            >
              {this.state.descriptionUpdateLoading ? 'Updating...' : 'Update Description'}
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </Modal>

      <Footer />
      
    </DashboardLayout>
    )  
  }  
}  

